export const environment = {
  production: false,
  appName: 'IDP-GENERATOR',
  version: '1.0.0',
  backendUrl: 'https://idp-dev-api.interplayers.com.br/VOUCHER-GENERATOR',
  authClientId: '30',
  authBaseUrl: 'https://idp-api-gtw.azure-api.net/scs-auth',
  forgotPasswordUrl: 'https://idpusrauth-api.azurewebsites.net',
  forgotPasswordConfirmationUrl: 'http://localhost:4200/reset-password',
  reportUrl: 'https://idprpt-api.azurewebsites.net',
  reportServiceUrl: 'https://idprpt-api.azurewebsites.net',
  authUserTokenValidationUrl: 'https://idpusrauth-api.azurewebsites.net',
  authServiceTokenValidationUrl: 'https://idp-api-gtw.azure-api.net/svc-auth',
  redirectOnExitingApp: 'login',
  pipUrl: 'https://idp-pip-app.azurewebsites.net/pip/app'
};

